/**
 * Base class for data accessing and providing
 */
export default class DataProvider
{
    /**
     * Refreshes the data and returns a promise containing the data
     * @param {any} context Contextual data required to return data
     * @return {Promise} returns a promise containing the data (elements field) and optional other fields
     */
    refreshData(context)
    { throw new Error('You have to implement the method refreshData'); }
}